import React, { useState , useEffect } from 'react'; 
import $ from 'jquery';
import Swal from 'sweetalert2'
import BA_curriculum_page from './BA_curriculum_page';
import BA_Pricing_card from './BA_Pricing_card';
import BA_Review_Program_Page from './BA_Review_Program_Page';
import BA_FAQ_page from './BA_FAQ_page';
import Certificates from '../Certificates';
import Counsellor from '../Counsellor';
import All_Program_Mentor from '../All_Program_Mentor';
import { Helmet } from 'react-helmet-async';
import { SlUser } from 'react-icons/sl'
import { HiOutlinePhone } from 'react-icons/hi'
import { MdOutlineMailOutline } from 'react-icons/md'
import { HiOutlineBuildingLibrary } from "react-icons/hi2";
import { LiaSwatchbookSolid } from "react-icons/lia";
import BA from "../image/BA.avif"
import DemoClass from '../DemoClass';

function BA_page() {

  const canonicalUrl = 'https://internselite.net/Business-Analytics';

  useEffect(()=>{
    document.title= 'Business Analytics | Traineeship Program | InternsElite';
  },[]);
  const [formData, setFormData] = useState({
    fullName: '',
    email: '',
    mobileNo: '',
    collegeName: '',
    programName: '',
  });

  const [nameError, setNameError] = useState(" ");
  const [emailError, setEmailError] = useState("");
  const [phoneError, setPhoneError] = useState("");
  const [collegeError, setCollegeError] = useState("");
  const [programError, setProgramError] = useState("");

  const handleInputChange = (event) => {
    const { name, value } = event.target;

    if (name === 'fullName') {
      if (!value || !/^[A-Za-z\s]+$/.test(value)) {
        setNameError(`Invalid name format.`);
      }

      else {
        setNameError("");
      }
    }

    if (name === 'email') {
      if (!value || !/\S+@\S+\.\S+/.test(value)) {
        setEmailError("Invalid email format");
      } else {
        setEmailError("");
      }

    }

    if (name === 'mobileNo') {
      if (!value || !/^\d{10}$/.test(value)) {
        setPhoneError("Length Should be 10 Digit");
      } else {
        setPhoneError("");
      }
    }
    if (name === 'collegeName') {
      if (!value || !/^[A-Za-z\s]+$/.test(value)) {
        setCollegeError(`Invalid College Name format.`);
      }
      else {
        setCollegeError("");
      }
    }
    if (name === 'programName') {
      if (!value || !/^[A-Za-z\s]+$/.test(value)) {
        setProgramError(`Invalid Program Name format.`);
      }
      else {
        setProgramError("");
      }
    }
    setFormData({
      ...formData,
      [name]: value,
    });
  };


  const handleSubmit = async (event) => {
    event.preventDefault();
    $.ajax({
      url: 'https://forms.internselite.net/traineeship/T12',
      type: 'POST',
      data: {
        fullName: $('[name="fullName"]').val(),
        mobileNo: $('[name="mobileNo"]').val(),
        email: $('[name="email"]').val(),
        collegeName: $('[name="collegeName"]').val(),
        programName: $('[name="programName"]').val()
      },
      success: function (response) {
        Swal.fire({
          title: "Form Submitted!",
          text: "Thank you for your interest in the Traineeship Program! Our counsellor will contact you within 24 hours with the next steps.",
          icon: "success"
        });
        $('[name="fullName"]').val('');
        $('[name="mobileNo"]').val('');
        $('[name="email"]').val('');
        $('[name="collegeName"]').val('');
        $('[name="programName"]').val('');
      },
      error: function (error) {
        console.error('Error:', error);
      }
    });
  };
  return (
    <>
    <style>{`
        .BA_program_details_image{
          background-image: url(${BA});
          background-repeat: no-repeat;
          background-size: cover;
          z-index:-1 !important;
        }
        .BA_program_details_image .background_color{
          background-image: linear-gradient(rgb(7, 7, 7,0.5), rgba(7,7,7,0.7));
          width:100%;
        }
      `}</style>
    <div>
    <Helmet>
        <title>Business Analytics Course | InternsElite: Transform Data into Insights</title>
        <meta name='description' content='Join InternsElite’s Business Analytics course to transform data into actionable insights. Learn from industry experts, gain practical experience in data analysis, and earn a professional certification. Advance your career in business analytics with our expert-led training.' />
        <meta name='keywords' content='business analytics, data analysis, online training, certification course, professional courses, analytics certification' />
        <meta property="og:title" content="Business Analytics Course | InternsElite: Transform Data into Insights" />
        <meta property="og:description" content="Join InternsElite’s Business Analytics course to transform data into actionable insights. Learn from industry experts, gain practical experience in data analysis, and earn a professional certification. Advance your career in business analytics with our expert-led training." />
        <meta property="og:url" content="https://internselite.net/Business-Analytics" />
        <meta property="og:type" content="website" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:site" content="@internselite" />
        <meta name="twitter:title" content="Business Analytics Course | InternsElite: Transform Data into Insights" />
        <meta name="twitter:description" content="Join InternsElite’s Business Analytics course to transform data into actionable insights. Learn from industry experts, gain practical experience in data analysis, and earn a professional certification. Advance your career in business analytics with our expert-led training." />
        <meta name="twitter:image" content="https://internselite.net/static/media/logo.c1eb8ff81ef75599f376.png" />
        <link rel="canonical" href={canonicalUrl} />
    </Helmet>


    {/* -----------------------Mobile view---------------- */}
    <div className='BA_program_details_image d-sm-block d-md-none'>
        <div className='container-fluid background_color py-5'>
            <div className='row mt-4'>
              <div className='col-md-12'>
                <div className='Details_Main_text'>
                  <h1 className='display-5 pt-5 text-white'>Business Analytics Traineeship Program</h1>
                  <h4 className='text-white pt-2'>Start Learning Business Analytics by Top Industry Experts...</h4>
                  <a href='#BA'><button className="text-white shadow-sm my-4 fs-5 px-4 pt-1 pb-2 Pr_details_button">Read More...</button></a>
              </div>
              </div>
              <div className='col-md-12'>
                <div className='Program_details_form  px-3'>
                    <div className='py-4'>
                    <p className='text-center fs-3'>Apply Now</p>
                    <form onSubmit={handleSubmit}>
                          <div class="mt-2">
                            <label for="fullName" class="pb-2 contact_form"><SlUser size="18px"/>{' '}Full Name</label>
                            <input
                              className='form-control'
                              type="text"
                              id="fullName"
                              name="fullName"
                              placeholder="Your answer"
                              value={formData.fullName}
                              onChange={handleInputChange}
                              required
                            />
                            {nameError && <div className="error text-danger">{nameError}</div>}
                          </div>
                          <div class="mt-3">
                            <label for="email" class="pb-2 contact_form"><MdOutlineMailOutline size="18px"/>{' '}Email Address</label>
                            <input
                              className='form-control'
                              type="email"
                              id="email"
                              name="email"
                              placeholder="Your answer"
                              value={formData.email}
                              onChange={handleInputChange}
                              required
                            />
                            {emailError && <div className="error text-danger">{emailError}</div>}
                          </div>
                          <div class="mt-3">
                            <label for="mobileNo" class="pb-2 contact_form"><HiOutlinePhone size="18px"/>{' '}Phone Number</label>
                            <input
                              className='form-control'
                              type="tel"
                              id="mobileNo"
                              name="mobileNo"
                              placeholder="+91 xxxxxxxxxx"
                              value={formData.mobileNo}
                              onChange={handleInputChange}
                              required
                            />
                            {phoneError && <div className="error text-danger">{phoneError}</div>}
                          </div>
                          <div class="mt-3">
                            <label for="collegeName" class="pb-2 contact_form"><HiOutlineBuildingLibrary size="18px"/>{' '}College Name</label>
                            <input
                              className='form-control'
                              type="text"
                              id="collegeName"
                              name="collegeName"
                              placeholder="Your answer"
                              value={formData.collegeName}
                              onChange={handleInputChange}
                              required
                            />
                            {collegeError && <div className="error text-danger">{collegeError}</div>}
                          </div>
                          <div class="mt-3">
                            <label for="programName" class="pb-2 contact_form"><LiaSwatchbookSolid size="18px"/>{' '}Program</label>
                            <input
                              type="text"
                              readonly class="form-control form-control-plaintext px-2"
                              id="programName"
                              placeholder="Your answer"
                              value="Business Analytics"
                              required />
                            {programError && <div className="error text-danger">{programError}</div>}
                          </div>
                          
                        <div className='row mt-2 pt-4'>
                          <div className='d-flex justify-content-center'>
                            <button className="text-white shadow-sm fs-5 px-5 pt-1 pb-2 Pr_details_button">Submit</button>
                          </div>
                        </div>
                    </form>
                    </div>  
                    </div>
              </div>
            </div>
        </div>
    </div>

    {/* -----------------Desktop View----------------- */}
    <div className='BA_program_details_image d-none d-md-block mt-5'>
        <div className='container-fluid background_color py-5'>
            <div className='row  mt-5'>
              <div className='col-md-7'>
                <div className='px-5 pt-5 Details_Main_text'>
                  <h1 className='display-5 mt-5 pt-5 text-white'>Business Analytics Traineeship Program</h1>
                  <h4 className='text-white pt-2'>Start Learning Business Analytics by Top Industry Experts...</h4>
                  <a href='#BA'><button className="text-white shadow-sm my-4 fs-5 px-4 pt-1 pb-2 Pr_details_button">Read More...</button></a>
              </div>
              </div>
              <div className='col-md-5 px-3 pt-2'>
              <div className='container'>
                <div className=''>
                <div className=''>
                <div className='Program_details_form px-5'>
                    <div className='py-4'>
                    <p className='text-center fs-3'>Apply Now</p>
                    <form onSubmit={handleSubmit}>
                          <div class="mt-2">
                            <label for="fullName" class="pb-2 contact_form"><SlUser size="18px"/>{' '}Full Name</label>
                            <input
                              className='form-control'
                              type="text"
                              id="fullName"
                              name="fullName"
                              placeholder="Your answer"
                              value={formData.fullName}
                              onChange={handleInputChange}
                              required
                            />
                            {nameError && <div className="error text-danger">{nameError}</div>}
                          </div>
                          <div class="mt-3">
                            <label for="email" class="pb-2 contact_form"><MdOutlineMailOutline size="18px"/>{' '}Email Address</label>
                            <input
                              className='form-control'
                              type="email"
                              id="email"
                              name="email"
                              placeholder="Your answer"
                              value={formData.email}
                              onChange={handleInputChange}
                              required
                            />
                            {emailError && <div className="error text-danger">{emailError}</div>}
                          </div>
                          <div class="mt-3">
                            <label for="mobileNo" class="pb-2 contact_form"><HiOutlinePhone size="18px"/>{' '}Phone Number</label>
                            <input
                              className='form-control'
                              type="tel"
                              id="mobileNo"
                              name="mobileNo"
                              placeholder="+91 xxxxxxxxxx"
                              value={formData.mobileNo}
                              onChange={handleInputChange}
                              required
                            />
                            {phoneError && <div className="error text-danger">{phoneError}</div>}
                          </div>
                          <div class="mt-3">
                            <label for="collegeName" class="pb-2 contact_form"><HiOutlineBuildingLibrary size="18px"/>{' '}College Name</label>
                            <input
                              className='form-control'
                              type="text"
                              id="collegeName"
                              name="collegeName"
                              placeholder="Your answer"
                              value={formData.collegeName}
                              onChange={handleInputChange}
                              required
                            />
                            {collegeError && <div className="error text-danger">{collegeError}</div>}
                          </div>
                          <div class="mt-3">
                            <label for="programName" class=" pb-2  contact_form"><LiaSwatchbookSolid size="18px"/>{' '}Program</label>
                            <input
                              type="text"
                              readonly class="form-control form-control-plaintext px-2"
                              id="programName"
                              placeholder="Your answer"
                              value="Business Analytics"
                              required />
                            {programError && <div className="error text-danger">{programError}</div>}
                          </div>
                          
                        <div className='row mt-2 pt-4'>
                          <div className='d-flex justify-content-center'>
                            <button className="text-white shadow-sm fs-5 px-5 pt-1 pb-2 Pr_details_button">Submit</button>
                          </div>
                        </div>
                    </form>
                    </div>
                </div>
                </div>
                </div>
              </div>
              </div>
            </div>
        </div>
    </div>

    <div className='py-5' id='BA'><BA_program_details/></div>

    <div className='Curriculum_Containte_box py-5'>
      <div className='container-fluid'>
        <div className='row'>
          <div className='col-md-2'></div>
          <div className='col-md-8'>
          <div className='text-center Curriculum_Main_text'>
                <h2 className='display-6 pb-1'>Program Curriculum</h2>
                <p className='px-2'>A comprehensive and dynamic syllabus designed to empower your skills and propel your success in every aspect of your professional and personal development.</p>
            </div>
          </div>
          <div className='col-md-2'></div>
        </div>
        <div className='row'>
          <div className='col-md-1'></div>
          <div className='col-md-10'>
          <div className='mt-3'>
            <BA_curriculum_page/>
          </div>
          <div className='col-md-1'></div>
          </div>
        </div>
      </div>
    </div>

    <Certificates/>
    <BA_Pricing_card/>
    <DemoClass/>
    {/* <All_Program_Mentor/> */}
    <BA_Review_Program_Page/>
    <BA_FAQ_page/>
    <Counsellor/>
    </div>
    </>
  )
}

function BA_program_details(){
  return(
    <>
    <div>
      {/* ---------------------mobile view-------------------- */}
      <div className="d-sm-block d-md-none">
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <div className="text-center Program_details_1stcomp_text_mobile">
                <h2 className="display-6">
                  Smart Business Analytics, Bright Future
                </h2>
                <p className="py-2">
                 Unlock the secrets of success with our Business Analytics program. Enroll now and harness the power of data. Chart your program toward a brilliant future!

                </p>
              </div>
              <div className="mt-4 text-center Program_details_1stcomp_text_mobile">
                <h2 className="display-2">Overview</h2>
                <p className="py-2">
                 With our in-depth training, you can start a career in Business Analytics. Learn Python while studying statistics and visualizing data. Explore databases like SQL, NoSQL, and Spark, along with other key data science tools. Master essential business analytics techniques and time series forecasting. Gain hands-on experience with Excel and web development. Improve your skills in data management, analysis, and strategic decision-making. Build practical expertise to succeed in the fast-growing field of Business Analytics.
                </p>
              </div>
            </div>
            <div className="col-md-12">
              <div>
                <div className=" Details_container shadow-lg px-1 py-4">
                  <h2 className="Details_text text-center  pb-2 border-bottom">
                    Business Analytics
                  </h2>
                  <div className="Details_text">
                    <ul className="pt-2">
                    <li>Learn from live expert sessions with industry professionals</li>
                    <li className="py-3">Project support and guidance</li>
                    <li>Access exclusive program material </li>
                    <li className="py-3">25+ learning hours</li>
                    <li>
                      Certification to boost your career profile and achieve growth & success                     
                    </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* ---------------------Desktop view----------------- */}
      <div className="d-none d-md-block">
        <div className="container">
          <div className="row">
            <div className="col-md-8 detail_1stcomp_img">
              <div className="pt-3 Program_details_1stcomp_text">
                <h2 className="fs-2">
                 Smart Business Analytics, Bright Future
                </h2>
                <p className="py-2">
                   Unlock the secrets of success with our Business Analytics program. Enroll now and harness the power of data. Chart your program toward a brilliant future!


                </p>
              </div>
              <div className="mt-3 Program_details_1stcomp_text">
                <h2 className="display-6">Overview</h2>
                <p className="py-2">
                  With our in-depth training, you can start a career in Business Analytics. Learn Python while studying statistics and visualizing data. Explore databases like SQL, NoSQL, and Spark, along with other key data science tools. Master essential business analytics techniques and time series forecasting. Gain hands-on experience with Excel and web development. Improve your skills in data management, analysis, and strategic decision-making. Build practical expertise to succeed in the fast-growing field of Business Analytics.
                </p>
              </div>
            </div>
            <div className="col-md-4">
              <div>
                <div className=" Details_container shadow-lg px-3 py-4">
                  <h3 className="Details_text text-center  pb-4 pt-3 border-bottom">
                    Business Analytics
                  </h3>
                  <div className="Details_text ">
                    <ul className="pt-3">
                     <li>Learn from live expert sessions with industry professionals</li>
                    <li className="py-3">Project support and guidance</li>
                    <li>Access exclusive program material </li>
                    <li className="py-3">25+ learning hours</li>
                    <li>
                      Certification to boost your career profile and achieve growth & success                     
                    </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    </>
  )
}
export default BA_page
